import { HttpErrorResponse } from "@angular/common/http";
import { ErrorHandler } from "@angular/core";
import { Utils } from 'src/modules/utils/shared/utils';
import { ErrorHandlingService } from '../services/error-handling-service';
import { LocatorService } from '../services/locator.service';
import { HttpConnectorError } from "../models/http-connector-error.model";

export class SmErrorHandler implements ErrorHandler {

    static instance: SmErrorHandler;
    onError: ((error: any) => void)[] = [];

    constructor() {
        SmErrorHandler.instance = this;
    }

    handleError(error: any): void {
        for (let f of this.onError) {
            f(error);
        }

        if (error instanceof HttpConnectorError && (error.response.status == 500 || error.response.status == 0 || error.response.status == 401 && error.response.message.includes("Unauthorized"))) {
            return;
        }

        console.log(error);
        console.trace(error);

        LocatorService.injector.get(ErrorHandlingService).reportToBackend(error as Error);
    }
}
